import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // To access query parameters
import {
  Container,
  Box,
  Typography,
  Paper,
  Card,
  CardContent,
  Button,
  Snackbar,
  Alert,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import DynamicFileUpload from "../common/DynamicFileUpload"; // The Dynamic File Upload component
import { vendorApi } from "../../api/api";
const AddDocument = () => {
  const [rows, setRows] = useState([
    {
      DocumentOrder: 0,
    }, // Initial row with orderId 0
  ]);
  const [loading, setLoading] = useState(false); // Loader state
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Snackbar severity
  const [isAdditionalDocument, setIsAdditionalDocument] = useState("no"); // Track if a row was added
  // Get query parameters from the URL
  const location = useLocation();
  const {
    ProjectName,
    City,
    Address,ProjectId
  } = location.state || {};
  const queryParams = new URLSearchParams(location.search);
  const [inputValue, setInputValue] = useState(ProjectName); // Initialize with passed data
  const [CityValue, setCity] = useState(City);
  const [AddressValue, setInvestors] = useState(Address);

  // Handle snackbar close
  const handleSnackbarClose = () => setSnackbarOpen(false);
  // Handle document type change
  const handleDocumentTypeChange = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].DocumentType = value;
    setRows(updatedRows);
  };
  // Handle text change
  const handleTextChange = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].DocumentName = value;
    setRows(updatedRows);
  };
  // Handle file change
  const handleFileChange = (index, file) => {
    // Check if the file is a PDF
    if (file && file.type !== "application/pdf") {
      setSnackbarMessage("Only PDF files are allowed.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show error snackbar
      return; // Stop execution if the file is not a PDF
    }
    const updatedRows = [...rows];
    updatedRows[index].file = file; // Store the file in the row object
    setRows(updatedRows);
  };
  // Remove a row
  const removeRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };
  // Add a new row
  const addRow = () => {
    // Set isAdditionalDocument to "yes" when a row is added
    setIsAdditionalDocument("yes");
    setRows([
      ...rows,
      {
        DocumentType: "Select Document Type",
        DocumentName: "",
        file: null,
        DocumentOrder: rows.length,
      },
    ]);
  };
  // Handle save
  const handleSave = async () => {
    setLoading(true); // Show loader
    const fd = new FormData();
    debugger;
    // Append isAdditionalDocument to FormData
    fd.append("isAdditionalDocument", isAdditionalDocument); // This will send the value "yes" if a new row was added
    // Array to hold the files
    const fileArray = [];
    // Loop over rows and append files one by one
    rows.forEach((row, index) => {
      if (row.file) {
        // Push the current file to the fileArray
        fileArray.push(row.file);
        var doc = {
          docType: row.DocumentType,
          docName: row.DocumentName,
          docOrder: row.DocumentOrder,
        };
        fd.append("Documents[]", JSON.stringify(doc));
      }
    });
    // Append files one by one
    fileArray.forEach((file, index) => {
      fd.append(`file[]`, file); // Append files one by one to FormData
    });
    
    try {
      if (!ProjectId) {
        console.error("Property ID is missing!");
        setSnackbarMessage("Failed to add documents. Property ID is missing.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }
      // Append propertyId to FormData
      fd.append("projectId", ProjectId);
     const response = await vendorApi.addProjectDocuments(fd);
      const data = response.data;
      setSnackbarMessage("Documents added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true); // Show success snackbar
    } catch (error) {
      console.error(error);
      setSnackbarMessage("Failed to add documents. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show error snackbar
    } finally {
      setLoading(false); // Hide loader
    }
  };
  return (
    <Container sx={{ py: 5, maxWidth: "80%" }}>
      {/* Loader */}
      <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{ color: "#13216E", fontWeight: 600, fontSize: "24px" }}
        >
          Add Document
        </Typography>
      </Box>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Card sx={{ width: "95%", marginBottom: 3 }}>
          <CardContent>
            <Typography
              variant="h5"
              sx={{ color: "#4E0DFF", fontSize: "20px" }}
            >
              {inputValue},
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ color: "#13216E", fontSize: "16px" }}
            >
              {CityValue},
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ color: "#13216E", fontSize: "16px" }}
            >
              {AddressValue}.
            </Typography>
            <Box sx={{ marginTop: "20px" }}>
              <DynamicFileUpload
                rows={rows}
                setRows={setRows}
                handleTextChange={handleTextChange}
                handleFileChange={handleFileChange}
                handleDocumentTypeChange={handleDocumentTypeChange}
                removeRow={removeRow}
                addRow={addRow}
              />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
              <Button
                variant="contained"
                color="primary"
                sx={{ mr: 2 }}
                onClick={() => setRows([])}
              >
                Reset
              </Button>
              <Button variant="contained" color="primary" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Paper>
    </Container>
  );
};
export default AddDocument;